import { LuneIntelligenceIcon, Text } from '@lune-fe/lune-ui-lib'
import { Box } from '@mui/material'

const AutoFillLabel = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                height: '32px',
                backgroundColor: `Blue25`,
                gap: 3 / 2,
                padding: '0px 8px',
                width: 'max-content',
                borderRadius: '8px',
            }}
        >
            <LuneIntelligenceIcon
                sx={{
                    color: `Blue500`,
                    width: '24px',
                    height: '24px',
                }}
            />
            <Text
                variant={'body3'}
                sx={{
                    color: `Blue600`,
                }}
            >
                Fields highlighted blue have been autofilled.
            </Text>
        </Box>
    )
}

export default AutoFillLabel
